export const checkMinMaxLength = (text: string, min: number | string, max: number | string): boolean =>
  !!text && text.length <= max && text.length >= min;
